module.exports = __webpack_public_path__ + "img/loading.9759d228.gif";